(function () {
    var $form = $('.long-term-hire form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [];

    $form.nod(metrics, options);
})();
